import PropertySearchBar from './PropertySearchBar.vue';

export default PropertySearchBar;
